import styled from 'styled-components';

export const StyledMain = styled.div`
  background: ${props => props.theme.colors.body};
  margin: 0 0 30px;
`
